module.exports = __webpack_public_path__ + "img/36acf7ee5d774f378b558f66382c77f5-60.8ac5eaa3.png";